export default "__VITE_ASSET__wNN81pg$__"